<div class="pp-card" fxLayout="column" style="position: relative; min-height: 470px">
    <div fxLayout="column" style="padding: 20px 20px 10px 20px">
      <p class="pp-title-o">CAT TOWN</p>
      <p class="pp-title-o">PUNKS <span class="pp-number">COUPON</span></p>
    </div>
    <img src="https://test-token.cattownpunks.com/k-cat-town-punks-coupons/1.jpg" alt="cat-img" class="pp-img">
    <p class="pp-name">FREE Dark Ritual</p>
    <p class="pp-rare">Quantity: {{item.amount}}</p>
</div>
